<div class="meeting-container">
  <!-- Tela de carregamento -->
  <div *ngIf="isLoading" class="loading">
    <div class="spinner"></div>
    <p>Carregando detalhes da reunião...</p>
  </div>

  <!-- Erro ao carregar a reunião -->
  <div *ngIf="errorMessage && !isLoading" class="error-message">
    <p>{{ errorMessage }}</p>
  </div>

  <!-- Exibir detalhes da reunião -->
  <div *ngIf="meetingData && !isLoading" class="meeting-card">
    <div class="header">
      <img *ngIf="meetingData.systemImage" [src]="meetingData.systemImage"
        alt="Logo do sistema" class="system-logo" />
      <h2>Detalhes da Reunião</h2>
    </div>

    <div class="meeting-content">
      <div class="content-wrapper">
        <div class="info">
          <p><strong>Descrição:</strong> {{ meetingData.description }}</p>
          <p><strong>Solução:</strong> {{ meetingData.system }}</p>
          <p><strong>Data e Hora:</strong> {{ meetingData.meetingDateTime }}</p>
          <div class="partner-info"
            *ngIf="meetingData.partners && meetingData.partners.length">
            <div class="partner-text">
              <p>
                <strong>TUTOR(s):</strong>
                <span class="partner-names">{{ partnerNames }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="partner-image-container"
          *ngIf="meetingData.partners && meetingData.partners.length">
          <img [src]="meetingData.partners[0].image" alt="Foto do parceiro"
            class="partner-image" />
        </div>
      </div>
      <a
        *ngIf="meetingData.linkMeeting && meetingData.linkMeeting !== 'Sem link'"
        [href]="meetingData.linkMeeting" target="_blank"
        rel="noopener noreferrer" class="join-button">
        Participar da Reunião
      </a>
      <div
        *ngIf="!meetingData.linkMeeting || meetingData.linkMeeting === 'Sem link'"
        class="no-link">
        <span>Sem link disponível</span>
      </div>
    </div>
  </div>
</div>
